import React from 'react'
import { Link } from 'react-router-dom'
import Button from 'components/Button'
import Card from '../Card'
import S from '../Card.style'

export interface AppCardProps {
	className?: string
	id: string
	name: string
	description: string
	image: string
	toolAPI?: string
	isSubscribed: boolean
	openLink?: string
	subscribeLink?: string
	webSite?: string
	submitHandler: Function
}

export const AppCard = ({
	className = '',
	id,
	name,
	description,
	image,
	toolAPI,
	isSubscribed,
	openLink,
	subscribeLink,
	webSite,
	submitHandler,
}: AppCardProps) => {
	const actions = () => {
		if (isSubscribed === true) {
			return (
				<React.Fragment>
					{openLink && (
						<Button as="a" href={openLink} target="_blank" rel="noopener noreferrer">
							Open App
						</Button>
					)}
					{webSite && (
						<Button as="a" href={webSite} target="_blank" rel="noopener noreferrer">
							Learn More
						</Button>
					)}
				</React.Fragment>
			)
		} else {
			return (
				<React.Fragment>
					{subscribeLink && (
						<Button as="a" href={subscribeLink} target="_blank" rel="noopener noreferrer">
							Subscribe
						</Button>
					)}
					{webSite && (
						<Button as="a" href={webSite} isOutline target="_blank" rel="noopener noreferrer">
							Learn More
						</Button>
					)}
				</React.Fragment>
			)
		}
	}

	return (
		<Card actions={actions()}>
			<div data-testid="AppCard" className={`w-full ${className}`}>
				<S.Image className="image" src={image} />
				<Link to={`/partnerapps/${id}`}>
					<S.Title>{name}</S.Title>
				</Link>
				<S.Description>
					{description.length > 90 ? `${description.slice(0, 90)}...` : description}
				</S.Description>
			</div>
		</Card>
	)
}

export default AppCard
